export function combine2StringArrays(arr1?: string[], arr2?: string[]): string[] {
	const set: Set<string> = new Set();
	if (arr1) insertArrayIntoSet(arr1, set);
	if (arr2) insertArrayIntoSet(arr2, set);
	return [...set];
}

function insertArrayIntoSet<T>(arr: T[], set: Set<T>): void {
	for (const element of arr) {
		set.add(element);
	}
}
